import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <p>Now, choose the one (or more) for which you’ve ticked the most
                                                boxes – these are your
                                                ‘signature’ strengths!</p>
                                            <p>The next stage is to consider how you can leverage these
                                                strengths and use them more. The next
                                                section will help you.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>CAPITALISING ON SIGNATURE STRENGTHS</div>
                                            <p>Asking yourself the following questions will help you discover
                                                whether you use your strengths
                                                currently and how you could capitalise on them, using them more
                                                often and in different ways. Use
                                                the table on the following page to help you work through
                                                this.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading  lightbgcenter">
                                                <p><span className="subtiltereg">What are the areas in which I currently use my signature strengths at work?</span>
                                                </p>
                                            </div>
                                            <ul className="taskul">
                                                <li>You could review your diary over the past month, or just
                                                    think through the work you’ve been
                                                    involved in, and identify where you have used your signature
                                                    strengths.
                                                </li>
                                            </ul>
                                            <p><span
                                                className="brown brownbold">Example:</span>&nbsp;&nbsp;  One of
                                                my signature strengths is meeting and building relationships
                                                with new people.
                                                I currently use this when I work with new clients.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading  lightbgcenter">
                                                <p><span className="subtiltereg">How often do I currently use my signature strengths at work?</span>
                                                </p>
                                            </div>
                                            <ul className="taskul">
                                                <li>Again, use your diary to gauge how much you actually use
                                                    your signature strength at work. Is
                                                    it every day? Every week? A few times per month? Or less?
                                                </li>
                                            </ul>
                                            <p><span className="brown brownbold">Example:</span>&nbsp;&nbsp;  I
                                                tend to meet new clients about twice a month, mostly when I work
                                                on new projects.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading  lightbgcenter">
                                                <p><span className="subtiltereg">Is there potential for me to do more of this within my role? If yes, how?</span>
                                                </p>
                                            </div>
                                            <ul className="taskul">
                                                <li>Are there opportunities to use your signature strength
                                                    more?
                                                </li>
                                            </ul>
                                            <p><span className="brown brownbold">Example:</span>&nbsp;&nbsp;  I
                                                can try to work on more new projects.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading  lightbgcenter">
                                                <p><span className="subtiltereg">Are there any other areas of work where I can use my signature strength?</span>
                                                </p>
                                            </div>
                                            <ul className="taskul">
                                                <li>What do you need to do in order to a) do more of the things
                                                    you currently do, and b) get involved more in them?
                                                </li>
                                            </ul>
                                            <p><span className="brown brownbold">Example:</span>&nbsp;&nbsp;  I
                                                can speak to the project managers about new projects and ask to
                                                be included in the
                                                team. I can also speak to the business development department
                                                and ask them if I can attend
                                                pitches for new business in my areas.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading  lightbgcenter">
                                                <p><span className="subtiltereg">Are there any barriers which might stop you or slow you down? If so, what actions will you
take to overcome these?</span></p>
                                            </div>
                                            <ul className="taskul">
                                                <li>Think about how this might impact the rest of your daily
                                                    role. Are they things you could do as
                                                    well? Are the ‘signature strength’ activities ones you could
                                                    do instead of others? If so, who
                                                    would you need to speak to about that? Do you have the other
                                                    skills required for these
                                                    activities? (be realistic here!)
                                                </li>
                                            </ul>
                                            <p><span className="brown brownbold">Example:</span>&nbsp;&nbsp; I
                                                can speak to my manager and ask that I be put on more projects
                                                less often, rather
                                                than the same project all the time. I might not be skilled in
                                                going to sales pitches, so I will start
                                                off by shadowing other people. The business is unlikely to pay
                                                for me to attend a conference
                                                without a clear business benefit, so I will put that option on
                                                hold for now.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }